import React from 'react';
import * as Layout from 'react-bootstrap';

const Footer = () => {
    return (
        <Layout.Row className='footer mt-2'>
            <Layout.Col md={{ span: 10, offset: 1 }} className='text-center py-2' style={{ fontSize: 13 }}>
                <a href='/legal/impressum' className='nav-link-color'>Impressum</a>
                {'  ·  '}
                <a href='/legal/privacy' className='nav-link-color'>Datenschutz / Privacy</a>
            </Layout.Col>
        </Layout.Row>
    );
}

export default Footer;